module.exports = __webpack_public_path__ + "static/img/bg-ar.e18c646d.png";